export default {
  state: {
    stageInfo: {
      test_material: {},
      text_material: {},
      extra_materials: [],
      file_materials: [],
      user: {},
      course: {
        stages: []
      }
    },
    userStageInfo: {
      test_material: {},
      text_material: {},
      extra_materials: [],
      file_materials: [],
      user: {},
      course: {
        stages: []
      }
    },
    stageHashes: [],
    stageExtraHashes: []
  },
  mutations: {
    setStageInfo: (state, { list }) => {
      state.stageInfo = list
    },
    setUserStageInfo: (state, { list }) => {
      state.userStageInfo = list
    },
    setStageHash: (state, { list }) => {
      state.stageHashes.push(list)
    },
    setStageExtraHash: (state, { list }) => {
      state.stageExtraHashes.push(list)
    }
  },
  actions: {}
}
